import api from "@/lib/axios";

export const companiesService = {
    //list all companies
    getAllCompanies: async (params) => {
        try {
            const response = await api.get("/companies", {
                params: params
            });
            return response.data;
        } catch (error) {
            throw new Error("Failed to fetch companies: " + error.message);
        }
    },

    

    //get company by id
    getCompanyById: async (id) => {
        try {
            const response = await api.get(`/companies/${id}`);
            return response.data;
        } catch (error) {
            throw new Error("Failed to fetch company: " + error.message);
        }
    },

  // create company
  createCompany: async (companyData) => {
    try {
      const response = await api.post("/company-with-profile", companyData,{headers: {
        "Content-Type": "multipart/form-data",
    }},);
      return response.data;
    } catch (error) {
      console.log("error messagge",error)
      if (error.response) {
        const apiError = error.response.data;
        const message = apiError.message || 'Validation error occurred';
    
        // Extract specific field errors (e.g., email)
        const fieldErrors = apiError.errors || {};
        // const emailError = fieldErrors.email ? fieldErrors.email[0] : null;
    
        console.log('General Message:', message);
        throw new Error("Failed to create company: " + message);
        if (emailError) {
          console.log('Email Error:', emailError);
        }
      } else {
        console.log('An unexpected error occurred:', error.message);
        throw new Error("Failed to create company: " + error.message);
      }
      
    }
  },

  // update company
  updateCompany: async (companyId, companyData) => {
    try {
      const response = await api.post(`/company/${companyId}`, companyData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error) {
      throw new Error("Failed to update company: " + error.message);
    }
  },

  // get all companies
  getAllCompany: async () => {
    try {
      const response = await api.get("/company/listing");
      return response.data;
    } catch (error) {
      throw new Error("Failed to fetch companies: " + error.message);
    }
  },
  // delete company
  deleteCompany: async (companyId) => {
    try {
      const response = await api.delete(`/companies/${companyId}`);
      return response.data;
    } catch (error) {
      throw new Error("Failed to delete company: " + error.message);
    }
  },

  // get company by slug
  getCompanyBySlug: async (slug) => {
    try {
      const response = await api.get(`/companies/slug/${slug}`);
      return response.data;
    } catch (error) {
      throw new Error("Failed to fetch company by slug: " + error.message);
    }
  },
  
  // Get all companies listing
  getCompaniesList: async (params = {}) => {
    try {
      const { data } = await api.get("/company/listing", { ...params });
      return data;
    } catch (error) {
      throw new Error("Failed to fetch companies: " + error.message);
    }
  },





  
  




  // update company
  
};
